import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

interface CardFacts {
  kicker: string;     // "ALUMINUM · DURA"
  sizeLabel: string;  // "48 IN" on the dimension bar
  spec: string;       // "48 in × 120 in · .032""
  unit: string;       // "sheet", from "Sold per"
}

/** Marketing product card (Wireframe_v2 "Featured & for you"). Shared by the homepage
 *  Featured carousel and the homepage Recently Bought section so the two stay identical.
 *  Everything shown comes from the product's own fields/attributes; nothing is invented:
 *  the stock flag needs inventoryQty, the price needs a price (only sent to signed-in
 *  customers). "Add" opens the product page, as "Add To Cart" did before. */
@Component({
  selector: 'app-featured-product-card',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './featured-product-card.component.html',
  styleUrl: './featured-product-card.component.css',
})
export class FeaturedProductCardComponent {
  @Input() item: any;
  @Input() signedIn = false;

  private _cacheItem: any = null;
  private _cacheFacts: CardFacts = { kicker: '', sizeLabel: '', spec: '', unit: '' };

  /** Derived labels, memoized per item reference so template reads stay cheap. */
  get facts(): CardFacts {
    if (this.item !== this._cacheItem) {
      this._cacheItem = this.item;
      this._cacheFacts = this.computeFacts(this.item);
    }
    return this._cacheFacts;
  }

  private computeFacts(item: any): CardFacts {
    const attrs: any[] = item?.attributesDTOs || [];
    const attr = (name: string) =>
      String(attrs.find(a => a?.attributeName === name)?.attributeValue ?? '').trim();
    // 48" x 120"  ->  48 in × 120 in
    const dims = (v: string) => v.replace(/"/g, ' in').replace(/\s+x\s+/gi, ' × ').replace(/\s+/g, ' ').trim();

    const size = attr('Size');
    const sku = attr('Manufacturers SKU');
    return {
      kicker: [attr('Material'), attr('Brand')].filter(Boolean).join(' · '),
      sizeLabel: dims(attr('Width') || size),
      spec: [dims(size), attr('Thickness'), sku && `SKU ${sku}`].filter(Boolean).join(' · '),
      unit: attr('Sold per').toLowerCase(),
    };
  }
}
